import React from "react";
import { DocHeading, DocPage } from "../components/doc-page.tsx";

export function Privacy() {
  return (
    <DocPage title="Privacy Policy">
      <p className="text-muted">Last updated: 2026-05-05</p>

      <p>
        This Privacy Policy describes how Long Division, LLC ("we," "us," or
        "our") collects, uses, and discloses information in connection with
        authed.co (the "Service").
      </p>

      <DocHeading>Information we collect</DocHeading>
      <p>
        We collect: (a) the email address you provide to sign in; (b) data you
        create through the Service, including application configurations,
        redirect URIs, and access code metadata; and (c) short-lived
        authentication tokens, which are deleted upon use or expiration.
      </p>

      <DocHeading>How we use information</DocHeading>
      <p>
        We use the information we collect to provide, operate, and maintain the
        Service, to authenticate users, and to communicate with you about your
        account.
      </p>

      <DocHeading>Information we do not collect</DocHeading>
      <p>
        We do not collect analytics, usage telemetry, advertising identifiers,
        or third-party tracking data.
      </p>

      <DocHeading>Disclosure</DocHeading>
      <p>
        We do not sell, rent, or share your information with third parties,
        except as required by law, to enforce our rights, or to protect the
        safety of any person.
      </p>

      <DocHeading>Service providers</DocHeading>
      <p>
        The Service is hosted on Cloudflare. Cloudflare may collect routine
        request logs as part of providing infrastructure services.
      </p>

      <DocHeading>Data retention</DocHeading>
      <p>
        We retain information for as long as your account is active or as
        needed to provide the Service. You may request deletion of your
        information at any time by contacting us.
      </p>

      <DocHeading>Security</DocHeading>
      <p>
        We use industry-standard practices to protect information, including
        HMAC-keyed hashing of access codes. No method of transmission or
        storage is fully secure, and we cannot guarantee absolute security.
      </p>

      <DocHeading>Children</DocHeading>
      <p>
        The Service is not directed to children under 13, and we do not
        knowingly collect personal information from them.
      </p>

      <DocHeading>Your rights</DocHeading>
      <p>
        Depending on your jurisdiction, you may have rights to access, correct,
        or delete your personal information. To exercise such rights, contact
        us using the details below.
      </p>

      <DocHeading>Changes</DocHeading>
      <p>
        We may update this Privacy Policy from time to time. Material changes
        will be indicated by updating the "last updated" date above.
      </p>

      <DocHeading>Contact</DocHeading>
      <p>
        <a href="mailto:solve@longdi.vision">solve@longdi.vision</a>
      </p>
    </DocPage>
  );
}
